<template>
  <div>
    <integration-page
      :integration-name="'google'"
      :svg="googleIcon"
      :links="links"
      :is-first-link="isFirstLink"
      @handleDelete="onOkDeletePopup"
      @firstLinkWasOpen="firstLinkWasOpen"
    />
  </div>
</template>

<script>

import _ from 'lodash';
import googleIcon from '../../../svg/integration/settings/googleCalendarSmall.svg';
import IntegrationPage from '../googleOutlookIntegrations/integrationPage.vue';
import projectComponent from '../../../components/Project';

export default {
  name: 'GoogleIntegration',
  components: {
    IntegrationPage,
  },
  data() {
    return {
      locale: __,
    };
  },
  computed: {
    links() {
      const projectsData = projectComponent.getProjectsList();

      const links = this.$store.getters['integrationGoogle/googleLinks'] || [];

      const projectsIds = _.cloneDeep(projectsData.filter(item => item.type === 'project' && !item.is_jira)).map(item => item.id);

      if (links.length) {
        const updatedData = links.filter(link => link.connectionType === 'all_tasks' || projectsIds.includes(link.projects[0].ganttId));

        return updatedData;
      }

      return [];
    },
    isFirstLink() {
      return this.$store.getters['integrationGoogle/isFirstLink'] || false;
    },

  },
  created() {
    this.googleIcon = googleIcon;
  },
  methods: {

    onOkDeletePopup(link) {
      this.$store.dispatch('integrationGoogle/deleteLink', link);
      userExtAnalytics.log('integration_google_calendar_deleted');
    },
    firstLinkWasOpen() {
      this.$store.commit('integrationGoogle/setFirstLink', false);
    },
  },
};
</script>

<style module src="../googleOutlookIntegrations/googleOutlookIntegration.less"></style>
